import React, { useState, useEffect } from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';
import {
  Navigation,
  Hero,
  About,
  VisionMission,
  LogoStrip,
  WhatWeDo,
  PGMPrices,
  WhyChoose,
  Sustainability,
  RecyclingProcess,
  Partner,
  Contact,
  Footer,
  SmoothScroll,
  LandingScreen,
} from './components';

const App: React.FC = () => {
  const [showLanding, setShowLanding] = useState(true);

  useEffect(() => {
    // Disable browser's scroll restoration and scroll to top on page load
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {showLanding && (
        <LandingScreen onComplete={() => setShowLanding(false)} duration={3000} />
      )}
      <SmoothScroll>
        <Box
          sx={{
            minHeight: '100vh',
            backgroundColor: 'white',
            overflow: 'hidden',
          }}
        >
          <Navigation />
          <Box id="home">
            <Hero />
          </Box>
          <Box id="about">
            <About />
            <VisionMission />
            <LogoStrip />
          </Box>
          <Box id="services">
            <WhatWeDo />
            <PGMPrices />
            <WhyChoose />
            <Sustainability />
            <RecyclingProcess />
          </Box>
          <Box id="contact">
            <Contact />
            <Partner />
            <Footer />
          </Box>
        </Box>
      </SmoothScroll>
    </ThemeProvider>
  );
};

export default App;
